import { BATTLESHIP, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import Big from 'UIComponents/elements/Big';
import MediaQuery from 'marketplace-ui-common/layout/components/MediaQuery';
import Rating from 'marketplace-ui-reviews/components/Rating';
import { STAR_RATING_FILLED } from 'marketplace-ui-reviews/constants/RatingTypes';
import PartnerTypeIcon from '../../components/PartnerTypeIcon';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import * as ProfileTierLabelKeys from '../../constants/ProfileTierLabelKey';
import { getProfileTierLabelI18nKey } from '../../utils/i18n';
import { getProfileLevelColorUse } from '../../utils/profiles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COMPANY_LOGO_HEIGHT = 50;
const COMPANY_LOGO_WIDTH = 85;
export default function ProfileSearchBarResult({
  logoUrl,
  name,
  partnerType,
  reviewSummary,
  tier
}) {
  const badgeI18nKey = getProfileTierLabelI18nKey(tier, partnerType, ProfileTierLabelKeys.TAG);
  return /*#__PURE__*/_jsx(MediaQuery, {
    minScreenSize: ScreenSizes.SM,
    alternate: /*#__PURE__*/_jsx(UIMediaObject, {
      align: "center",
      itemLeft: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        justify: "center",
        style: {
          height: COMPANY_LOGO_HEIGHT / 2,
          width: COMPANY_LOGO_WIDTH / 2,
          padding: 4,
          backgroundColor: OLAF
        },
        children: /*#__PURE__*/_jsx(UIImage, {
          src: logoUrl,
          style: {
            maxHeight: '100%'
          }
        })
      }),
      spacing: "medium",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex-column justify-center",
        children: /*#__PURE__*/_jsx(UIFlex, {
          align: "center",
          children: /*#__PURE__*/_jsx(Big, {
            style: {
              whiteSpace: 'pre-wrap'
            },
            className: "display-block",
            children: /*#__PURE__*/_jsx("span", {
              className: "is--heading-7",
              style: {
                display: 'inline'
              },
              children: name
            })
          })
        })
      })
    }),
    children: /*#__PURE__*/_jsx(UIMediaObject, {
      align: "center",
      itemLeft: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        justify: "center",
        style: {
          height: COMPANY_LOGO_HEIGHT,
          width: COMPANY_LOGO_WIDTH,
          padding: 4,
          backgroundColor: OLAF,
          border: `1px solid ${BATTLESHIP}`
        },
        children: /*#__PURE__*/_jsx(UIImage, {
          src: logoUrl,
          style: {
            maxHeight: '100%'
          }
        })
      }),
      spacing: "medium",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex-column justify-center p-top-2",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("b", {
            children: name
          }), badgeI18nKey && /*#__PURE__*/_jsx(UIBadge, {
            className: "m-left-2",
            use: getProfileLevelColorUse(partnerType, tier),
            children: /*#__PURE__*/_jsxs(UIFlex, {
              align: "center",
              children: [/*#__PURE__*/_jsx(PartnerTypeIcon, {
                className: "m-right-1",
                partnerType: partnerType,
                size: 12,
                tier: tier
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: badgeI18nKey
              })]
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "m-y-2",
          children: reviewSummary.overallRating > 0 && /*#__PURE__*/_jsx(Rating, {
            iconSize: "xxs",
            rating: reviewSummary.overallRating,
            label: reviewSummary.reviewCount,
            use: "card",
            type: STAR_RATING_FILLED
          })
        })]
      })
    })
  });
}